import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export function createRouter() {
    return new Router({
        // mode: 'history',
        routes: [{
            path: '/',
            redirect(to) {
                return {
                    path: '/index',
                    query: to.query
                };
            }
        }, {
            path: '/index',
            name: 'home',
            component: resolve => require(['../pages/index.vue'], resolve)
        }, {
            path: '/search',
            name: 'search',
            component: resolve => require(['../pages/search/index.vue'], resolve)
        },

            // 趣味测试
        {
            path: '/ceshi/:id(\\d+)',
            name: 'detail',
            meta: {allowPC:1},
            component: resolve => require(['../pages/test/funDetail.vue'], resolve)
        }, {
            path: '/ceshi/:id(\\d+)/answer',
            name: 'answer',
            meta: {allowPC:1},
            component: resolve => require(['../pages/test/answer.vue'], resolve)
        }, {
            path: '/ceshi/:id(\\d+)/result/:resultId(\\d+)',
            name: 'fun-result',
            meta: {allowPC:1},
            component: resolve => require(['../pages/test/funResult.vue'], resolve)
        },

            // 测评
        {
            path: '/assessment/:type/:id(\\d+)/comment',
            name: 'assessment-comment',
            meta: {allowPC:1},
            component: resolve => require(['../pages/assessment/comment.vue'], resolve)
        },
        //     {
        //     path: '/assessment/:type/:id(\\d+)/comment/publish',
        //     name: 'assessment-publish-comment',
        //     component: resolve => require(['../pages/assessment/publish-evaluate.vue'], resolve)
        // },

            // 个人中心
        {
            path: '/manage',
            name: 'user',
            meta: {allowPC:1},
            redirect(to) {
                return {
                    path: '/manage/0',
                    query: to.query
                };
            }
        },
        {
            path: '/manage/:type(\\d+)',
            name: 'userReal',
            meta: {allowPC:1},
            component: resolve => require(['../pages/user/index.vue'], resolve)
        }, {
            path: '/collect',
            name: 'collect',
            meta: {allowPC:1},
            component: resolve => require(['../pages/user/collect.vue'], resolve)
        },{
            path: '/memberActivty',
            name: 'memberActivty',
            meta: {allowPC:1},
            component: resolve => require(['../pages/member/memberActivty.vue'], resolve)
        },
        {
            path: '/vipDetail',
            name: 'vipDetail',
            meta: {allowPC:1},
            component: resolve => require(['../pages/member/vipDetail.vue'], resolve)
        },
        {
            path: '/vipRights',
            name: 'vipRights',
            meta: {allowPC:1},
            component: resolve => require(['../pages/member/vipRights.vue'], resolve)
        },
        // 双十二活动
        {
            path: '/20inPromotion',
            name: '20inPromotion',
            meta: { allowPC: 1},
            component: resolve => require(['../pages/activity/20DoubleEleven/index.vue'], resolve)
        },
        {
            path: '*',
            meta: {allowPC:1},
            component: resolve => require(['../pages/404.vue'], resolve)
        }, {
          path: '/professionalTest',
          name: 'professionalTest',
          component: resolve => require(['../pages/professionalTest/index.vue'], resolve)
      },]
    })
}



// WEBPACK FOOTER //
// ./src/router/index.js